import { assign } from '../../../../lib/assign';
import { layoutChange, layoutSetMenuState, layoutPreviewStatus } from './layout.actions';
import { LayoutState, MenuState, PreviewStatus } from './layout.model';
import { LayoutActionsService } from './layout.actions.service';
import { createReducer, on } from '@ngrx/store';
import { StorageUtils } from '../../../utils/storage-utils';

const INITIAL_STATE: LayoutState = {
    previewVisible: StorageUtils.getBoolean(LayoutActionsService.previewVisibleStoragePath),
    previewStatus: StorageUtils.getNumber(LayoutActionsService.previewStatusStoragePath, PreviewStatus.Horizontal),
    menuState: StorageUtils.getNumber(LayoutActionsService.menuStateStoragePath, MenuState.Float)
};

export const layoutReducer = createReducer(
    INITIAL_STATE,
    on(layoutPreviewStatus, (state, { previewStatus }) => assign(state, { previewStatus: previewStatus })),
    on(layoutChange, (state, { previewVisible }) => assign(state, { previewVisible: previewVisible })),
    on(layoutSetMenuState, (state, { menuState }) => assign(state, { menuState: menuState }))
);